import DashboardWrapper from '../../../customized/fresh-watch/components/Dashboard/DashboardWrapper';
import { ToggleComponent } from '../../../featureToggle';
import DashboardPage from './DashboardPage';

export default ToggleComponent(DashboardPage, {
  styledComponentsVariants: {
    'fresh-watch': DashboardWrapper,
  },
});
